import OnestockDashboardOnboardedContainer from "./OnestockDashboardOnboardedContainer";
import OnestockDashboardOnboardedStore from "./OnestockDashboardOnboardedStore";
export default OnestockDashboardOnboardedStore(OnestockDashboardOnboardedContainer)